import { createFileRoute } from "@tanstack/react-router";
import ElectricHub from "@/pages/hub/ElectricHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/hub/electric/")({
  head: () => routeHead("/de/hub/electric/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ElectricHub />
  );
}
